module.exports = __webpack_public_path__ + "img/skin-diagnostic-icon.b64f813a.svg";